/* eslint-disable @typescript-eslint/consistent-type-assertions */

import type { Client, RequestContext } from "../client";
import type { GetTeamsLookupBffResponse, GetTeamsLookupBffResponseTeam, ResourceCollection, ScopedUserRoleResource, TeamResource } from "../resources";
import type { ListArgs } from "./basicRepository";
import { MixedScopeBaseRepository } from "./mixedScopeBaseRepository";

interface TeamListArgs extends ListArgs {
    spaces?: string | string[];
    ids?: string | string[];
    includeSystem?: boolean;
    partialName: string;
}

export class TeamRepository extends MixedScopeBaseRepository<TeamResource, TeamResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Teams", client, requestContext);
    }

    listScopedUserRoles(team: TeamResource, pagination?: { take?: number; skip?: number }): Promise<ResourceCollection<ScopedUserRoleResource>> {
        if (!pagination) {
            return this.client.get(this.requestContext, team.Links["ScopedUserRoles"], this.spacePartitionParameters());
        }

        return this.client.get(this.requestContext, team.Links["ScopedUserRoles"], { ...this.spacePartitionParameters(), ...pagination });
    }

    list(args?: TeamListArgs): Promise<ResourceCollection<TeamResource>> {
        return super.list(args) as Promise<ResourceCollection<TeamResource>>;
    }

    async lookupBff(ids?: string[], systemOnly?: boolean): Promise<GetTeamsLookupBffResponseTeam[]> {
        // If there are a large number of arguments, return everything
        const args = ids && ids.length <= 500 ? { ids, systemOnly: !!systemOnly } : { systemOnly: !!systemOnly };
        const combinedArgs = super.extend(this.spacePartitionParameters(), args);

        const response = await this.client.get<GetTeamsLookupBffResponse>(this.requestContext, "~/bff/teams/lookup/{?ids,spaces,includeSystem,systemOnly}", combinedArgs);
        return response.Teams;
    }
}
